import React from 'react';
import styles from './features.module.scss';
import baseStyles from '@framework/ui/Pages/Landing/Sections/base.module.scss';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';
import IconCheckCircle from '@dealroadshow/uikit-icon/IconCheckCircle';

interface IProps {
  title: string,
  description: string,
  collection: string[][],
  isExploreButtonExists: boolean,
}

const renderFeaturesColumn = (item: string[], i: number) => (
  <div className={ styles.featuresColumn } key={ i }>
    { item.map(renderCollectionItem) }
  </div>
);

const renderCollectionItem = (item: string, i: number) => (
  <div className={ styles.feature } key={ i }>
    <div className={ styles.featureIcon }>
      <IconCheckCircle />
    </div>
    <div className={ styles.featureTitle }>{ item }</div>
  </div>
);

const Features = (props: IProps) => (
  <SectionContainer size="small" narrow>
    <div className={ styles.features }>
      <SectionContainer size="small">
        <div className={ baseStyles.sectionTitle }>{ props.title }</div>
        <div className={ baseStyles.sectionDescription }>{ props.description }</div>
      </SectionContainer>
      <div className={ cardStyles.cardContainer }>
        <div className={ styles.featuresContainer }>
          <div className={ styles.featuresRow }>
            { props.collection.map(renderFeaturesColumn) }
          </div>
          { props.isExploreButtonExists
            ? (
              <div className={ styles.featuresCta }>
                <Button
                  variant={ ButtonVariantType.firm }
                  className={ styles.featuresCtaBtn }
                  title="Explore Our Features"
                  dataTest="featuresFirmButton"
                />
              </div>
            )
            : null }
        </div>
      </div>
    </div>
  </SectionContainer>
);

export default Features;
